module.exports = __webpack_public_path__ + "img/man.84d7fce2.svg";